import { Home } from "lucide-react";
import { useRouterState } from "@tanstack/react-router";
import { getRouteTitle } from "@/lib/navigation";
import { buildPathWithPeriod, getPeriodNavigationSearch } from "@/lib/periodNavigation";

export function Breadcrumbs() {
  const location = useRouterState({ select: (state) => state.location });
  const pathname = location.pathname;
  const search = getPeriodNavigationSearch((location.search as Record<string, unknown>) ?? {});
  const segments = pathname.split("/").filter(Boolean);

  const items = segments.map((segment, index) => {
    const path = `/${segments.slice(0, index + 1).join("/")}`;
    return {
      path,
      label: getRouteTitle(path),
    };
  });

  return (
    <nav className="shrink-0 border-b bg-background px-3 py-2 text-xs text-muted-foreground [@media(max-height:500px)]:hidden sm:px-6 sm:py-3" aria-label="Breadcrumb">
      <ol className="flex items-center gap-2">
        <li>
          <a href={buildPathWithPeriod("/overview", search)} className="inline-flex items-center hover:text-foreground">
            <Home size={14} />
          </a>
        </li>
        {items.map((item) => (
          <li key={item.path} className="inline-flex items-center gap-2">
            <span>/</span>
            <a href={buildPathWithPeriod(item.path, search)} className="hover:text-foreground">
              {item.label}
            </a>
          </li>
        ))}
      </ol>
    </nav>
  );
}
